/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Result for Cursor hook events
 */
export type CursorHookResult = {
  /**
   * Additional context to inject into the conversation
   */
  additionalContext?: string | undefined;
  /**
   * Message sent back to the agent (beforeMCPExecution only)
   */
  agentMessage?: string | undefined;
  /**
   * Permission decision for preToolUse / beforeMCPExecution: allow, deny, or ask
   */
  permission?: string | undefined;
  /**
   * Message to display to the user
   */
  userMessage?: string | undefined;
};

/** @internal */
export const CursorHookResult$inboundSchema: z.ZodMiniType<
  CursorHookResult,
  unknown
> = z.pipe(
  z.object({
    additional_context: z.optional(z.string()),
    agent_message: z.optional(z.string()),
    permission: z.optional(z.string()),
    user_message: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "additional_context": "additionalContext",
      "agent_message": "agentMessage",
      "user_message": "userMessage",
    });
  }),
);

export function cursorHookResultFromJSON(
  jsonString: string,
): SafeParseResult<CursorHookResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CursorHookResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CursorHookResult' from JSON`,
  );
}
